<div class="tooltip-wrapper" [style.z-index]="zIndex"
    (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <ng-content></ng-content>
    <div class="tooltip" [class.show]="showTooltip"
        [class.top]="position === 'top'" [class.bottom]="position === 'bottom'"
        [class.left]="position === 'left'" [class.right]="position === 'right'">
        <span class="tooltip-text">{{ text }}</span>
    </div>
</div>